export enum API_METHOD {
    GET,
    POST,
    PUT,
    PATCH,
    DELETE
  }
  
  // eslint-disable-next-line @typescript-eslint/no-namespace
  export namespace API_METHOD {
    export function isGET(method: API_METHOD): boolean {
      return method === API_METHOD.GET;
    }
  
    export function isPOST(method: API_METHOD): boolean {
      return method === API_METHOD.POST;
    }
  
    export function isPUT(method: API_METHOD): boolean {
      return method === API_METHOD.PUT;
    }
  
    export function isPATCH(method: API_METHOD): boolean {
      return method === API_METHOD.PATCH;
    }
  
    export function isDELETE(method: API_METHOD): boolean {
      return method === API_METHOD.DELETE;
    }
  }
  